import React, { Fragment, memo, useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Today } from '@mui/icons-material';
import { voidFunc } from 'js/constants/PropTypeUtils';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers';
import Styles from './CreateUpdateSeasonDateInput.module.less';
import Typography from '@mui/material/Typography';
import moment from 'moment';

const CreateUpdateSeasonDateInput = (props: CreateUpdateSeasonDateInput.propTypes) => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [value, setValue] = useState(props.date);

  useEffect(() => {
    setValue(props.date);
  }, [props.date]);

  const setDate = useCallback(
    (date) => {
      if (!date) {
        return;
      }

      setValue(date);
      props.onChanged(date);
      setCalendarOpen(false);
    },
    [props.onChanged]
  );

  const handleSetCalendarOpen = (val) => () => {
    setCalendarOpen(val);
  };

  return (
    <Fragment>
      <Box className={Styles.root}>
        <Typography variant="caption" className={Styles.title}>
          {props.title}
        </Typography>

        <DatePicker
          open={calendarOpen}
          onOpen={handleSetCalendarOpen(true)}
          onClose={handleSetCalendarOpen(false)}
          value={value ? moment(value) : null}
          onChange={setDate}
          minDate={props.minDate ? moment(props.minDate) : undefined}
          maxDate={props.maxDate ? moment(props.maxDate) : undefined}
          format={props.format}
          disableFuture={false}
          slots={{ openPickerIcon: Today }}
          slotProps={{
            textField: {
              className: Styles.datePicker,
              // InputLabelProps: { shrink: true },
              inputProps: { readOnly: true, 'data-lpignore': true, autoComplete: 'off' },
              InputProps: { classes: { input: Styles.input, root: Styles.inputRoot } },
              onClick: handleSetCalendarOpen(true),
            },
          }}
        />
      </Box>
    </Fragment>
  );
};

CreateUpdateSeasonDateInput.propTypes = {
  title: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChanged: PropTypes.func,
  format: PropTypes.string,
};

CreateUpdateSeasonDateInput.defaultProps = {
  title: '',
  onChanged: voidFunc,
  variant: 'outlined',
  format: 'YYYY-MM-DD',
};

export default memo(CreateUpdateSeasonDateInput);
